import axiosService from '@services/axiosService';

const attendeeEndpointPrefix = '/api/Attendees';

export const sendTranscriptCompletionEmailToAttendee = ({
  attendeeId,
  transcriptIds,
  token,
}) =>
  axiosService.post(
    `${attendeeEndpointPrefix}/${attendeeId}/send-email-with-transcription?access_token=${token}`,
    transcriptIds,
  );



// WEBPACK FOOTER //
// ./services/attendeeResourse.js